export const API_URLS = {
	AUTH: {
		LOGIN: (smsLogin?: number) => `/auth?lang=en${!!smsLogin ? `&smsLogin=${smsLogin}` : ""}`,
		VALIDATE_REGISTERING_PROFILE: "/validate/user-register?lang=en",
		SIGN_UP: "/profiles?lang=en",
		COMPLETE: "/profiles/complete?lang=en",
		CHECK: "/auth/check?lang=en",
		REFRESH_TOKEN: "/auth/refreshToken?lang=en",
		LOGOUT: "/auth",
		REQUEST_PASSWORD_RESET: "/userPassword"
	},
	USER: {
		PROFILE_INFO: "/profiles?lang=en",
		USER_INFO: "/userInfo?lang=en",
		UPDATE_PASSWORD: "/userPassword?lang=en",
		GET_AUTHENTICATOR_SETTINGS: "/auth/2fa/google",
		VALIDATE_AUTHENTICATOR_CODE: "/auth/2fa/google"
	},
	BONUSES: {
		LIST: "/bonuses?lang=en"
	},
	GAMES: {
		LIST: "/games?lang=en",
		LAUNCH: "/games/launch?lang=en",
		FAVORITE: (gameId: string) => `/favorites/${gameId}?lang=en`,
		LIST_FAVORITES: "/favorites"
	},
	BOOTSTRAP: {
		GET: "/bootstrap"
	},
	LOYALTY: {
		LEVELS: "/loyalty/levels",
		STORES: "/store"
	},
	BETS: {
		LIST: "/bets",
		LIST_SPORT_BETS: "/sport-bets",
		LAST_GAME_ACTIONS: "/LastNGameActions"
	},
	SUPPORT: {
		EMAIL: "/supportEmail"
	},
	COUNTRIES: {
		LIST: "/countries"
	},
	CURRENCIES: {
		LIST: "/currencies"
	},
	TOURNAMENTS: {
		LIST: "/tournaments",
		HISTORY: "/tournaments/history",
		JOIN: (id: number) => `/tournaments/${id}`,
		LEADERBOARD: (id: number) => `/tournaments/${id}/top`
	},
	TRANSACTIONS: {
		LIST: "/transactions"
	},
	PAYMENT: {
		LIST_SYSTEMS: "/paymentSystems"
	},
	GITBOOK: {
		GET_PAGE_CONTENT: (spaceId: string, pageId: string) => `/spaces/${spaceId}/content/page/${pageId}`
	},
	DOCS: {
		VALIDATE: "/docs",
		TYPES: "/docs/types"
	}
};
